// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Work+Sans:wght@700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/gemunu-libre);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rakkas&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  font-family: "Work Sans", sans-serif;
}

.title {
  font-family: "Work Sans", sans-serif;
  text-align: center;
  margin: 100px;
  font-size: 30px;
}

@media (max-width: 425px) {
  .title {
    margin: 80px;
  }

  .App {
    width: 100%;
  }

  .servicesTitle {
    position: absolute;
    top: 807px;
    right: -62%;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAIA;EACE,kBAAA;EACA,oCAAA;AAAF;;AAGA;EACE,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAAF;;AAGA;EACE;IACE,YAAA;EAAF;;EAGA;IACE,WAAA;EAAF;;EAGA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;EAAF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Work+Sans:wght@700&display=swap');\n@import url('https://fonts.cdnfonts.com/css/gemunu-libre');\n@import url('https://fonts.googleapis.com/css2?family=Rakkas&display=swap');\n\n.App {\n  text-align: center;\n  font-family: 'Work Sans', sans-serif;\n}\n\n.title{\n  font-family: 'Work Sans', sans-serif;\n  text-align: center;\n  margin: 100px;\n  font-size: 30px;\n}\n\n@media (max-width: 425px){\n  .title{\n    margin: 80px;\n  }\n\n  .App{\n    width: 100%;\n  }\n\n  .servicesTitle{\n    position: absolute;\n    top:807px;\n    right:-62%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
